import { forEachTree } from './index'

export interface FormatAccess {
    signup: Array<any>,
    select: Array<any>,
    work_launch: Array<any>,
    work_shortlist: Array<any>,
    work_hire: Array<any>,
    contributor_apply: Array<any>,
    project_accept: Array<any>,
    photo_work: Array<any>,
    contribution_work: Array<any>,
    channel_work: Array<any>,
    wallpaper:Array<any>,
}

export enum accessPoint {
    signup = 61,
    select = 62,
    work_launch = 12,
    work_shortlist = 13,
    work_hire = 14,
    contributor_apply = 15,
    project_accept = 16,
    photo_work = 63,
    contribution_work = 64,
    channel_work = 80,
    wallpaper = 1100,
};

export default function ( data = [] ): FormatAccess {
    let formatAccess: FormatAccess = {
        signup: [],
        select: [],
        work_launch: [],
        work_shortlist: [],
        work_hire: [],
        contributor_apply: [],
        project_accept: [],
        photo_work: [],
        contribution_work: [],
        channel_work: [],
        wallpaper:[]
    }

    forEachTree((window as any).$menuAccess.top_banner, (item) => {
        let childs = item.child
        if( childs && childs.length) {
            if(
                +item.id === accessPoint.signup ||
                +item.id === accessPoint.select ||
                +item.id === accessPoint.work_launch ||
                +item.id === accessPoint.work_shortlist ||
                +item.id === accessPoint.work_hire ||
                +item.id === accessPoint.contributor_apply ||
                +item.id === accessPoint.wallpaper) {
                    formatAccess[accessPoint[item.id]] = childs.map(item => ({ business_type: item.business_type }))
            }else if(+item.id === accessPoint.project_accept) {
                let access = childs.map(item => {
                    if(item.child) {
                        let checkStops = item.child.map((item) => item.check_steps).filter(item => item)

                        return { check_steps: checkStops.join(','), business_type: item.business_type}
                    }
                }).filter(item => item && item.check_steps)

                formatAccess[accessPoint[item.id]] = access
            }else if(+item.id === accessPoint.photo_work || +item.id === accessPoint.contribution_work || +item.id === accessPoint.channel_work ) {
                let access = childs.map(item => item.check_steps).filter(item => item).join(',')

                formatAccess[accessPoint[item.id]].push({ check_steps: access })
            }
        }

    }, 'child')

	return formatAccess;
};
